/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Uppbeat.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  HttpValidationProblemDetails,
  PostReferralSourceClickTrackingRequestBody,
  ProblemDetails
} from '../model';

import { apiClient } from '../../lib/api-client';




export const postApiV1ReferralSourceClickTrackings = (
    postReferralSourceClickTrackingRequestBodyNull: PostReferralSourceClickTrackingRequestBody | null,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/referral-source-click-trackings`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postReferralSourceClickTrackingRequestBodyNull, signal
    },
      );
    }




export const getPostApiV1ReferralSourceClickTrackingsMutationOptions = <TError = HttpValidationProblemDetails | null | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1ReferralSourceClickTrackings>>, TError,{data: PostReferralSourceClickTrackingRequestBody | null}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1ReferralSourceClickTrackings>>, TError,{data: PostReferralSourceClickTrackingRequestBody | null}, TContext> => {

const mutationKey = ['postApiV1ReferralSourceClickTrackings'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1ReferralSourceClickTrackings>>, {data: PostReferralSourceClickTrackingRequestBody | null}> = (props) => {
          const {data} = props ?? {};

          return  postApiV1ReferralSourceClickTrackings(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1ReferralSourceClickTrackingsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1ReferralSourceClickTrackings>>>
    export type PostApiV1ReferralSourceClickTrackingsMutationBody = PostReferralSourceClickTrackingRequestBody | null
    export type PostApiV1ReferralSourceClickTrackingsMutationError = HttpValidationProblemDetails | null | ProblemDetails

    export const usePostApiV1ReferralSourceClickTrackings = <TError = HttpValidationProblemDetails | null | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1ReferralSourceClickTrackings>>, TError,{data: PostReferralSourceClickTrackingRequestBody | null}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1ReferralSourceClickTrackings>>,
        TError,
        {data: PostReferralSourceClickTrackingRequestBody | null},
        TContext
      > => {
      return useMutation(getPostApiV1ReferralSourceClickTrackingsMutationOptions(options), queryClient);
    }
